var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upload-container" },
    [
      _c(
        "el-button",
        {
          style: { background: _vm.color, borderColor: _vm.color },
          attrs: { icon: "el-icon-upload", size: "mini", type: "primary" },
          on: { click: _vm.handleUpload },
        },
        [_vm._v("\n    上传图片")]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "调整图片顺序",
            visible: _vm.sortDialogVisible,
            width: "600px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.sortDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "sort-tips" }, [
            _vm._v("拖拽图片可调整顺序，确认后按顺序插入编辑器"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { ref: "sortListRef", staticClass: "sort-list" },
            _vm._l(_vm.pendingUrls, function (url, index) {
              return _c(
                "div",
                {
                  key: url,
                  staticClass: "sort-item",
                  attrs: { draggable: "true" },
                  on: {
                    dragstart: function ($event) {
                      return _vm.onDragStart(index)
                    },
                    dragover: function ($event) {
                      $event.preventDefault()
                      return _vm.onDragOver(index)
                    },
                    dragend: _vm.onDragEnd,
                  },
                },
                [
                  _c("div", { staticClass: "sort-index" }, [
                    _vm._v(_vm._s(index + 1)),
                  ]),
                  _vm._v(" "),
                  _c("img", { staticClass: "sort-img", attrs: { src: url } }),
                  _vm._v(" "),
                  _c("div", { staticClass: "sort-name" }, [_vm._v("拖动排序")]),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.sortDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmInsert },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }